import BlueButton from "../../../../common/BlueButton/BlueButton";
import UploadTemplatesCardContainer from "./uploadedTemplatesCardContainer";
import { useTranslation } from "react-i18next";
import PriceSelector from "../../../../common/PriceSelector";
const ImageCardDisplayElement = ({
    uploadedTemplates,
    removeUploadedTemplateQuestion,
    selectUploadedTemplate,
    removeSelectedUploadedTemplateFromSelection,
    selectedTemplates,
    priceOptions,
    updateSelectedTemplate,
}) => {
    const { t } = useTranslation("templatesPage");

    // Create an array to store all the JSX elements
    let arr = [];

    if (uploadedTemplates.length) {
        uploadedTemplates.forEach((item, i) => {
            // If item is hidden, return nothing
            if (item.isHidden) return <></>;

            const selectedItem = selectedTemplates.find(
                (selected) => item.thumbnailUrl === selected.thumbnailUrl,
            );

            if (selectedItem) item.type = "SELECTED";
            else item.type = "UPLOADED";

            // Define the right content based on whether the template is selected or not
            let rightContent =
                item.type === "UPLOADED" ? (
                    <>
                        <p>{item.message ? item.message : ""}</p>
                        <BlueButton
                            isCenter={true}
                            text={t("selectButton")}
                            onClick={() => selectUploadedTemplate(item)}
                        />
                    </>
                ) : (
                    <>
                        <p>{item.message ? item.message : ""}</p>
                        <PriceSelector
                            defaultValue={selectedItem.price || "0"}
                            onChange={(e) =>
                                updateSelectedTemplate(
                                    selectedItem,
                                    e.target.value,
                                    selectedItem.name,
                                )
                            }
                            priceList={priceOptions}
                            isValid={priceOptions[selectedItem.price]}
                        />
                        <br />
                        <BlueButton
                            isCenter={true}
                            text={t("unselectButton")}
                            isDark={true}
                            onClick={() =>
                                removeSelectedUploadedTemplateFromSelection(
                                    item,
                                )
                            }
                        />
                    </>
                );

            // Create the content component
            let content = (
                <UploadTemplatesCardContainer
                    item={item}
                    isLoading={false}
                    removeItem={removeUploadedTemplateQuestion}
                    isButtonGray={false}
                    contentRight={rightContent}
                    contentLeft={
                        item.publicTemplate ? (
                            <p>{t("uploadPageVisibalToEveryone")}</p>
                        ) : null
                    }
                />
            );

            // Add the content to the array
            arr.push(<div key={i}>{content}</div>);
        });
    }

    // Return the array of JSX elements
    return <>{arr}</>;
};

export default ImageCardDisplayElement;
